<div class="loadable" [class.loading]="reports.length === 0">
    <div class="card-grid" role="list">
        <app-reporting-card
            *ngFor="let report of reports"
            [report]="report"
            [disableRouterLink]="true"
            (click)="showReport(report)"
        />
    </div>
</div>
